import VueI18n from 'vue-i18n';
import { PhoenixRouteConfig } from '@front-app/router/Model';
import { Routes } from '@front-app/constants/routes';

export const addMembers: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				// TODO: Add group title here as well, somehow
				return i18n.t('group-admin.add-members.add-members') as string;
			},
		},
		path: 'add-members',
		name: Routes.GROUP_ADMIN_ADD_MEMBERS,
		// eslint-disable-next-line max-len
		component: () => import(/* webpackChunkName: "group-admin-add-members" */ '@front-app/views/home/group/admin/addMembers/AddMembers.vue'),
	},
	{
		meta: {
			title(i18n: VueI18n): string {
				// TODO: Add group title here as well, somehow
				return i18n.t('invitation-campaign.title') as string;
			},
		},
		path: 'invite-campaign',
		name: Routes.GROUP_ADMIN_INVITE_CAMPAIGN,
		// eslint-disable-next-line max-len
		component: () => import(/* webpackChunkName: "group-admin-invite-campaign" */ '@front-app/views/home/group/admin/addMembers/InviteCampaign.vue'),
	},
];
